module.exports = __webpack_public_path__ + "static/media/nimona@2x.b679f374.png";